import { render, staticRenderFns } from "./tab-quote-details-description.vue?vue&type=template&id=39e3bba2"
import script from "./tab-quote-details-description.vue?vue&type=script&lang=ts"
export * from "./tab-quote-details-description.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports